/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import CheckInNotificationDumb from './CheckInNotificationDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification<>,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => ({
  notification,
  user: getSelf(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,

  handleDismiss() {
    dispatch(dismissNotification(notification));

    trackGAEvent('Self check-in', 'Dismiss notification', 'Notification');
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInNotificationDumb);
